// import store from 'vuex'
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'
import Vue from 'vue'

// const mocks = {
//   'lists': { 'POST': { token: 'This-is-a-mocked-token' } },
//   'lists': { 'GET': { name: 'doggo', title: 'sir' } }
// }

const apiCall = ({url, method, user}) => new Promise((resolve, reject) => {
  let url2 = `${Vue.prototype.$globals.apiserver}${url}`
  let okresponse = ''
  // let errresponse = ''
  // console.log(url)
  // console.log(method)
  // console.log('apiCall')
  // console.log(url)
  // console.log(method)

  setTimeout(() => {
    try {
      if (method === 'POST') {
        axios.post(url2, { user: user })
        .then(response => {
          // console.log('response POST')
          // console.log(response.data)
          okresponse = response.data
          resolve(okresponse)
        })
        .catch((err) => {
          // errresponse = err
          // console.log('err POST')
          // console.log(err)
          reject(new Error(err))
        })
      } else {
        axios.get(url2, { user: user })
        .then(response => {
          // console.log('response GET')
          // console.log(response)
          okresponse = response.data
          resolve(okresponse)
        })
        .catch((err) => {
          // errresponse = err
          // console.log('err GET')
          // console.log(err)
          reject(new Error(err))
        })
      }
  // console.log(url)
  // console.log(store)
  // console.log(mocks)
  // console.log(mocks[url][method || 'GET'])
  // this.loginFailed())

  // var u = this.$store.state.users.find(u => user.login === user.username)
  // console.log('test')
  // console.log(this.$store.state.users)
  // if (u && u.id > 0) {
  //   this.$router.push({path: `/lists`})
  //   this.$store.commit('LOGIN_USER', u)
  // } else {
  //   this.error = 'Wrong login.'
  //   console.log('Wrong login.')
  // }
  // resolve(okresponse)
  // console.log(okresponse)
    } catch (err) {
      // console.log(errresponse)
      // console.log('error in api resolve')
      reject(new Error(err))
    }
  }, 2000)
})

export default apiCall



// WEBPACK FOOTER //
// ./src/utils/api.js